import { z } from "zod/v4";
import { matchRowSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export interface TournamentMatchesParams {
	tournament?: string;
	round?: string;
	limit?: number;
}

export const tournamentMatches = {
	list: (params: TournamentMatchesParams = {}) => {
		const query = new URLSearchParams();
		if (params.tournament) query.set("tournament", params.tournament);
		if (params.round) query.set("round", params.round);
		if (params.limit) query.set("limit", String(params.limit));
		const qs = query.toString();
		return fetchApi(`/matches${qs ? `?${qs}` : ""}`, z.array(matchRowSchema));
	},
};
